/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelFactoringCompanyLookup.ts        *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/factoring-company-lookup";

export class AutogenModelFactoringCompanyLookup<RowType extends ModelRow> extends Endpoint<RowType, RowFactoringCompanyLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowFactoringCompanyLookup extends ModelRow<RowFactoringCompanyLookupFields> {
	constructor(values?: Partial<RowFactoringCompanyLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowFactoringCompanyLookupFields {
	ach_batch_class_code: string;
	address: string;
	check_payee: string;
	city: string;
	company_id: string;
	email: string;
	external_xref: string;
	id: string;
	is_active: string;
	name: string;
	payment_method: string;
	phone_number: string;
	state: string;
	zip_code: string;
}

